//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,toCopy} from '@/utils/util.js'
import {uploadFile} from '@/utils/auth'
import footerNav from '@/components/footerNav'
import { Dialog,Toast } from 'vant';
import homeTip from '@/components/homeTip'

export default {
  name: "qualityOrderDetail",
  components: {
    footerNav,
    homeTip
  },
  data() {
    return {
      toCopy,
      reasonList:[
        {reason:'面料疵点',number:5,type:'一般'},
        {reason:'面料疵点',number:5,type:'一般'},
        {reason:'面料疵点',number:5,type:'一般'},
        {reason:'面料疵点',number:5,type:'一般'},
      ],
      fileList:[],
      value:'',
      showPicker:false,
      columns:[{text:'是',value:1},{text:'否',value:0}],
      basicForm: {
        qualityOrderSn: '',
        sendOrderSn: '',
        purchaseOrderSn: '',
        supplierName: '',
        channelStr: '',
        qualityOrderTypeName: '',
        qualityOrderDetailList: [],
        qualityOrderResultDetailList: [],
        attachedFile: [],
        isStockIn:'',
        confirmFileStr:'',
        confirmFile:'',
        remark:'',
        qualityResult:'',
        qualityOrderStatusName:'',
        billDate:'',
        externalOrder:'',
        needAduit:'',
        spuCode:'',
        sendTotalGoodsNum:'',
        crtTime:'',
        colorValue:'',
        qualityOrderStatus:''
      },
      qualityOrderId:'',
      isSend:false,
      isSend2:false,
    }
  },
  created() {
  },
  mounted() {
    console.log(this.$store.state.btnList)
    if (this.$route.query.qualityOrderId) {
      this.qualityOrderId = this.$route.query.qualityOrderId
    }
    this.getSpecList()
  },
  methods: {
    hasBtn(id){
      return this.$store.state.btnList.indexOf(id)!=-1
    },
    getSpecList() {
      var queryParams = {
        qualityOrderId:this.qualityOrderId
      };
      axiosApi.queryQualityOrder(queryParams).then(response => {
        var data = response.content;
        if(data.qualityOrderDetailList){
          data.qualityOrderDetailList.forEach((item)=>{item.isEdit = true})
        }
        for (var ind in data) {
          var val = data[ind] != null ? data[ind] : ""
          this.$set(this.basicForm, ind, val)
        }
        var channelStr = '';
        if(this.basicForm.firstDeptName){
          channelStr+=this.basicForm.firstDeptName
        }
        if(this.basicForm.secondDeptName){
          channelStr+='/'+this.basicForm.secondDeptName
        }
        if(data.attachedFile&&data.attachedFile.length>0){
          data.attachedFile.forEach((item)=>{
            this.fileList.push({url:item})
          })
        }
        this.$set(this.basicForm, 'channelStr', channelStr)
        // this.$refs.commonTableRef2.reloadDone()
      }).catch(error => {
        // this.$refs.commonTableRef2.reloadDone()
      })
    },
    toMore(){
      this.$router.push({name:'qualityOrderDetailMore'})
    },
    toBase(){
      this.$router.push({name:'allQualityDetailAll',query:{qualityOrderId:this.qualityOrderId}})
    },
    toAddReason(){
      this.$router.push({name:'addReason',type:2})
    },
    onConfirm(value) {
      this.value = value.text;
      this.basicForm.qualityResult = value.value;
      this.showPicker = false;
    },
    open(){
      if(this.basicForm.qualityOrderStatus!=0)return
      this.showPicker = true
    },
    afterRead(file) {
      this.canSubmit = false
      // console.log(file)
      // console.log(this.fileList)
      if(Array.isArray(file)){
        for (var i in file){
          uploadFile(file[i].file, 'file', url => {
            // this.basicForm.confirmFileStr = url.slice(url.lastIndexOf('/'))
            this.basicForm.attachedFile.push(url)
            if(i==(file.length-1)){
              this.canSubmit = true
            }
          });
        }
      }else{
        uploadFile(file.file, 'file', url => {
          // this.basicForm.confirmFileStr = url.slice(url.lastIndexOf('/'))
          this.basicForm.attachedFile.push(url)
          this.canSubmit = true
        });
      }
    },
    delImg (file, detail) {
      return new Promise((resolve, reject) => {
        this.basicForm.attachedFile.splice(detail.index, 1)
        resolve();
      });
    },
    save(type,key) {
      if(this[key])return
      this[key] = true
      // if (!this.checkNum()) {
      //   this.$message.error('添加不合格原因的件数与质检结果的不合格件数不对应');
      //   return
      // }
      // for (var i = 0; i < this.basicForm.qualityOrderDetailList.length; i++) {
      //   var num = 0
      //   if (this.basicForm.qualityOrderDetailList[i].goodNum) {
      //     num += parseInt(this.basicForm.qualityOrderDetailList[i].goodNum)
      //   }
      //   if (this.basicForm.qualityOrderDetailList[i].badNum) {
      //     num += parseInt(this.basicForm.qualityOrderDetailList[i].badNum)
      //   }
      //   if (num > parseInt(this.basicForm.qualityOrderDetailList[i].sendGoodsNum)) {
      //     this.$message.error('合格数加不合格数不能大于抽检数');
      //     return
      //   }
      // }
      var queryParams = {
        ...this.basicForm,
        qualityOrderStatus: type,
      }
      axiosApi.updateComQualityOrder(queryParams).then(response => {
        Toast.success('操作成功');
        this[key] = false
        if (type != 0) {
          this.$router.back(-1)
        }
      }).catch(error => {
        this[key] = false
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityAllOrder/detail.vue